import Dinero from 'dinero.js';
import { RoyaltiesAccountState } from './state';

export const royaltiesInitialState: RoyaltiesAccountState = {
  payouts: [],
  statements: [],
  paid: Dinero({ amount: 0, currency: 'USD', precision: 2 }),
  balance: Dinero({ amount: 0, currency: 'USD', precision: 2 }),
  artists: {},
};
